module.exports = __webpack_public_path__ + "media/assets/images/icons/patient-page/lack-of-response-24b12a2878b735cfc2ffe9bfa3d07297.svg";